<app-header (isOpened)="onOpenSideBar($event)" [isopenFlag]="isOpenSideBar" (sideNavElementEmitter)="receiveHeaderElement($event)"></app-header>
<div class="main-content-area" >
    <div class="app-sidebar" [ngClass]="{'toggleSideNav': isOpenSideBar }" #sideNav>
        <div class="menu-icon-wrapper" [ngClass]="[!isOpenSideBar ? 'd-none':'open-menu']">
            <div class="my-co-creator-logo">
                <img src="assets/icons/Logo.svg" alt="side-bar-logo">
            </div>

            <div class="close-sidebar" (click)="closeSideBar()">
                <div>
                    <img src="/assets/icons/right.svg" style="margin-bottom: 2px" alt="right arrow icon">
                </div>
                <div>
                    <img src="/assets/icons/Group 2436_black.svg" alt="icon">
                </div>

            </div>
        </div>
        <app-side-menu-bar [SideBarOpen]="isOpenSideBar"></app-side-menu-bar>
    </div>

    <div class="app-content-bar" [ngClass]="{'toggleContentBar': isOpenSideBar }">
        <router-outlet></router-outlet>
    </div>

</div>